import { PagesModule } from 'pages/pages.module';
import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { IntroCarouselPage } from 'pages/intro-carousel-page/intro-carousel-page';

@NgModule({
    declarations: [IntroCarouselPage],
    imports: [PagesModule, ComponentsModule],
    exports: [IntroCarouselPage]
})
export class IntroCarouselPageModule { }
